import img from '../../assets/images/avtar/emoji/7.png';
import img8 from '../../assets/images/avtar/emoji/8.png';
import img4 from '../../assets/images/avtar/emoji/4.png';
import img1 from '../../assets/images/avtar/emoji/1.png';
import Tshirt from '../../assets/images/product/small/tshirt.png';
import bag from '../../assets/images/product/small/bag.png';
import headphone from '../../assets/images/product/small/headphone.png';
import chair from '../../assets/images/product/small/chair.png';

export const messageData = [
    {
        id: 1,
        img: img,
        online: 'status-circle online',
        name: 'Erica Hughes',
        mess: 'okay, trying now.',
        badge: 'badge badge-primary',
        time: '32 min',
    },
    {
        id: 2,
        img: img8,
        online: 'status-circle away',
        name: 'Kori Thomas',
        mess: 'i could help in some of bug?',
        badge: 'badge badge-success',
        time: '58 min',
    },
    {
        id: 3,
        img: img4,
        online: 'status-circle offline',
        name: 'Ain Chavez',
        mess: 'Its working awesome :)',
        badge: 'badge badge-danger',
        time: '1 hr',
    },
    {
        id: 4,
        img: img1,
        online: 'status-circle offline',
        name: 'Johan deo',
        mess: 'Great Thanks you !!',
        badge: 'badge badge-danger',
        time: '2 hr',
    },
];

export const ItemCartData = [
    {
        id: 1,
        img: Tshirt,
        title: 'Woman T-shirt - yellow',
        prize: '200$',
        qty: 'Qty',
    },
    {
        id: 2,
        img: bag,
        title: 'Woman bag - purple',
        prize: '100$',
        qty: 'Qty',
    },
    {
        id: 3,
        img: headphone,
        title: 'Unisex headphone - Red',
        prize: '2000$',
        qty: 'Qty',
    },
    {
        id: 4,
        img: chair,
        title: 'Ergonomic Chair',
        prize: '920$',
        qty: 'Qty',
    }
];